// extracted by mini-css-extract-plugin
export default {"button":"button_button__PCLkP","trash":"button_trash__mdSYy"};